<script>
/* eslint-disable */
import { mapState } from 'vuex';
import ScheduledServiceTimeModel from '@models/ScheduledServiceTime';
import BlockingContainer from '@components/BlockingContainer';
import ECharts from 'vue-echarts';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import flatPickr from 'vue-flatpickr-component';
import datePickerUtility from '@mixins/datePickerUtility';
import { DateTime } from 'luxon';
import cloneDeep from 'lodash.clonedeep';
import Multiselect from 'vue-multiselect';
import map from 'lodash/map';
import debounce from 'lodash/debounce';
import ScheduledServiceTimeModal from '@views/jobs/scheduledServiceTimes/edit-scheduled-service-time';
import HeaderComponent from '@components/HeaderComponent';
import Layout from '@layouts/main';

// ECharts
// import ECharts modules manually to reduce bundle size
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent } from 'echarts/components';

use([CanvasRenderer, GridComponent, TooltipComponent, TitleComponent, LineChart]);

export default {
  page() {
    return {
      title: this.$t('titles.planning_view'),
    };
  },
  mixins: [datePickerUtility],
  components: {
    Layout,
    BlockingContainer,
    ECharts,
    FontAwesomeIcon,
    flatPickr,
    Multiselect,
    ScheduledServiceTimeModal,
    HeaderComponent,
  },
  props: {
    locations: {
      required: true,
      type: Array,
      default: null,
    },
    areas: {
      required: true,
      type: Array,
      default: null,
    },
    pageTitle: {
      required: true,
      default: '',
      type: String,
    },
  },
  data() {
    return {
      sortBy: 'vip',
      sortDesc: false,
      focused: false,
      fieldsTable: [
        { key: 'vip', label: this.$t('table_labels.vip'), sortable: true, class: 'font-weight-bold' },
        { key: 'location_from', label: this.$t('table_labels.location_from'), sortable: true },
        { key: 'location_to', label: this.$t('table_labels.location_to'), sortable: true },
        { key: 'driver_or_service_provider', label: this.$t('table_labels.driver_or_service_provider'), sortable: true },
        { key: 'car', label: this.$t('table_labels.lic_plate'), sortable: true },
        { key: 'car_type', label: this.$t('table_labels.car_type'), sortable: true },
        { key: 'chart', label: this.$t('table_labels.timeline'), sortable: false, class: 'p-0 align-middle', thStyle: 'width: 40%;' },
      ],
      isBusy: false,
      filters: {
        date: null,
        areasAndLocations: null,
        search: null,
        sort_by_start_timestamp: 0,
      },
      areasAndLocations: [],
      headerChartData: null,
      selectedScheduledServiceTime: null,
      selectedScheduledServiceTimeJob: null,
      sortByStartTimeOptions: [
        { text: this.$t('titles.on'), value: 1 },
        { text: this.$t('titles.off'), value: 0 },
      ],
      defaultHeaderData: {
        'grid': {
				  'left': 5,
				  'top': 0,
				  'right': 0,
				  'bottom': 20,
        },
			  // 'colors': [],
			  'title': {
				  'show': false
        },
			  'tooltip': {
				  'show': false,
				  'confine': true,
				  'trigger': 'axis',
        },
			  'xAxis': [
				  {
					  'min': null,
					  'max': null,
					  'maxInterval': 3600 * 1000 * 12,
					  'type': 'time',
					  'minorTick': {
						  'show': true,
						  'splitNumber': 6,
            },
					  'axisLabel': {
						  'show': true,
              'fontSize': 10,
            },
					  'splitLine': {
						  'interval': 1,
						  'show': false,
            },
          }
			  ],
			  'yAxis': [
          {
					  'minInterval': 1,
					  'maxInterval': 1,
					  'interval': 1,
					  'show': false,
					  'type': 'value',
					  'axisLabel': {
						  'rich': {
							  '0': {
								  'height': 40,
								  'align': 'center',
								  'backgroundColor': {
									  'image': '',
                  }
                }
              }
            }
          }
			  ],
			'series': []
      },
    }
  },
  mounted() {
    this.areasAndLocations = [
      {
        type: this.$t('fields.areas'),
        options: this.areas,
      },
      {
        type: this.$t('fields.locations'),
        options: this.locations,
      },
    ];

    this.$nextTick(() => {
      this.filters.date = DateTime.local().toFormat('yyyy-M-dd');
    });
  },
  computed: {
    sortDir() {
      return this.sortDesc ? '-' : '';
    },
    ...mapState({
      dateConfig: (state) =>
        Object.assign({}, state.common.dateConfig, {
          defaultDate: DateTime.local().toFormat('yyyy-M-dd'),
        }),
    }),
  },
  watch: {
    filters: {
      handler() {
        this.$nextTick(() => {
          this.$refs.asyncTable.refresh();
        });
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    updateSST() {
      this.$refs.asyncTable.refresh();
      this.resetSelectedSST();
    },
    onChartClick(sst, e) {
      this.$nextTick(() => {
        this.selectedScheduledServiceTime = sst.id;
        this.selectedScheduledServiceTimeJob = sst.job;
      });
    },
    resetSelectedSST() {
      this.selectedScheduledServiceTime = null;
      this.selectedScheduledServiceTimeJob = null;
    },
    formatDate(date) {
      return DateTime.fromSQL(date).toFormat('dd.MM.yyyy HH:mm');
    },
    onChartMouseOver(chartData) {
      chartData.tooltip.show = true;
    },
    onChartMouseOut(chartData) {
      chartData.tooltip.show = false;
    },
    customLocationName({ name }) {
      return name;
    },
    onRowClicked(item, index, event) {
      // dirty fix to disable chart redirect to edit page
      if (event.target.localName !== 'canvas') {
        const routeData = this.$router.resolve({ name: 'jobs.edit', params: { id: item.job.id } });
        window.open(routeData.href, '_blank');
      }
    },
    setHeaderChartDataFromDate() {
      const startDate = DateTime.fromSQL(this.filters.date).toFormat('yyyy-M-dd');
      const endDate = DateTime.fromSQL(this.filters.date).plus({days: 2}).toFormat('yyyy-M-dd') + ' 23:59:59';
      this.headerChartData = cloneDeep(this.defaultHeaderData)
      this.headerChartData.xAxis[0].min = startDate;
      this.headerChartData.xAxis[0].max = endDate;
      this.headerChartData.grid.bottom = 35;
      this.headerChartData.grid.top = 5;
      this.headerChartData.xAxis[0].axisLabel.formatter = (value) => {
        const dt = DateTime.fromMillis(value);
        const hour = dt.hour;
        const minute = dt.minute;
        
        // Only show day abbreviation at midnight (00:00)
        if (hour === 0 && minute === 0) {
          const dayAbbr = dt.toFormat('ccc').substring(0, 2);
          const date = dt.toFormat('dd');
          return `{day|${dayAbbr}}\n{date|${date}}`;
        } else {
          // Just show the hour for non-midnight times
          return dt.toFormat('HH:mm');
        }
      };
      this.headerChartData.xAxis[0].axisLabel.rich = {
        day: {
          fontSize: 10,
          color: '#333',
          fontWeight: 'bold',
          lineHeight: 12,
        },
        date: {
          fontSize: 10,
          color: '#666',
          fontWeight: 'bold',
          lineHeight: 14,
        },
      };
      this.$nextTick(() => {
        this.$refs.echart.setOption(this.headerChartData);
      });
    },
    setHeaderChartData(item) {
      this.headerChartData = cloneDeep(item);
      // set chart xAxis to be visible
      this.headerChartData.xAxis[0].axisLabel.show = true;
      this.headerChartData.xAxis[0].axisLabel.fontSize = 10;
      this.headerChartData.xAxis[0].axisLabel.formatter = (value) => {
        const dt = DateTime.fromMillis(value);
        const hour = dt.hour;
        const minute = dt.minute;
        
        // Only show day abbreviation at midnight (00:00)
        if (hour === 0 && minute === 0) {
          const dayAbbr = dt.toFormat('ccc').substring(0, 2);
          const date = dt.toFormat('dd');
          return `{day|${dayAbbr}}\n{date|${date}}`;
        } else {
          // Just show the hour for non-midnight times
          return dt.toFormat('HH:mm');
        }
      };
      this.headerChartData.xAxis[0].axisLabel.rich = {
        day: {
          fontSize: 10,
          color: '#333',
          lineHeight: 12,
          fontWeight: 'bold',
        },
        date: {
          fontSize: 10,
          color: '#666',
          fontWeight: 'bold',
          lineHeight: 14,
        },
      };
      this.headerChartData.xAxis[0].splitLine.show = false;
      this.headerChartData.xAxis[0].minorTick.show = true;
      this.headerChartData.series = [];

      // fix grid to show x axis label - increase bottom for two-line labels
      this.headerChartData.grid.bottom = 35;
      this.headerChartData.grid.top = 5;

      this.$nextTick(() => {
        this.$refs.echart.setOption(this.headerChartData);
      });
    },
    itemsProvider(ctx) {
      if (this.filters.date) {
        return ScheduledServiceTimeModel.orderBy(this.sortDir + ctx.sortBy)
          .where('date', this.filters.date)
          .where('search', this.filters.search)
          .where('sort_by_start_timestamp', this.filters.sort_by_start_timestamp)
          .params({
            areas_and_locations: map(this.filters.areasAndLocations, 'id'),
          })
          .get()
          .then((response) => {
            if(response.length > 0) {
              const items = map(response, (item) => {
                const startDate = this.formatDate(item.start_timestamp);
                const endDate = this.formatDate(item.end_timestamp);
                item.chart_data.tooltip.formatter = () => `${startDate} - ${endDate}`;
                return item;
              });
              this.setHeaderChartData(items[0].chart_data);
              return items;
            } else {
              this.setHeaderChartDataFromDate();
              return [];
            }
          })
          .catch(() => []);
      } else {
        return [];
      }
    },
    setDateToToday() {
      this.filters.date = DateTime.local().toFormat('yyyy-M-dd');
    },
    clearFilters() {
      this.filters.area = null;
      this.filters.date = null;
      this.filters.search = null;
      this.filters.sort_by_start_timestamp = 0;
    },
    updateFilter: debounce(function (value) {
      this.filters.search = value;
    }, 500),
  },
};
</script>
<style lang="css">
.custom-tbody-tr-class > td {
  border-color: #000;
  /* overflow: hidden; */
  /* white-space: nowrap; */
}
</style>
<template>
  <Layout>
    <b-row class="mb-4">
      <b-col>
        <HeaderComponent :title="pageTitle" :button-text="$t('titles.create_job')" @button-pressed="$router.push({ name: 'jobs.create' })"></HeaderComponent>
      </b-col>
    </b-row>
    <b-row class="mb-4 pb-2">
      <b-col class="mb-3 mb-md-0" sm="12" md="4" lg="4">
        <HeaderComponent>
          <template v-slot:header>
            <span>{{ $t('fields.date') }}</span>
          </template>
        </HeaderComponent>
        <b-input-group>
          <flat-pickr v-model="filters.date" v-validate="''" :config="dateConfig" class="form-control-sm" :placeholder="$t('placeholders.date')"> </flat-pickr>
          <b-input-group-append>
            <b-btn variant="secondary" size="sm" class="text-white border-gray" @click="setDateToToday">{{ $t('actions.today') }}</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col class="mb-3 mb-md-0" sm="12" md="4" lg="4">
        <HeaderComponent>
          <template v-slot:header>
            <span>{{ $t('fields.areas_and_locations') }}</span>
          </template>
        </HeaderComponent>
        <b-input-group>
          <div class="multiselect-container kks-multiselect-container-index form-control form-control-sm p-0" :class="{ focused: focused }">
            <Multiselect
              v-model="filters.areasAndLocations"
              :options="areasAndLocations"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :placeholder="$t('placeholders.areas_and_locations_multiple')"
              :label="$t('fields.locations')"
              :custom-label="customLocationName"
              track-by="id"
              group-values="options"
              group-label="type"
              @open="focused = true"
              @close="focused = false"
              >&nbsp;</Multiselect
            >
          </div>
          <b-input-group-append>
            <b-btn
              variant="secondary"
              size="sm"
              class="text-white border-gray"
              :disabled="!filters.areasAndLocations"
              @click="filters.areasAndLocations = []"
              >{{ $t('actions.clear') }}</b-btn
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col class="mb-3 mb-md-0" sm="12" md="4" lg="4">
        <HeaderComponent>
          <template v-slot:header>
            <span>{{ $t('fields.search') }}</span
            >&nbsp;
            <small class="pt-01">
              {{
                $t('search.message', {
                  entity: [
                    $t('search.entities.vip'),
                    $t('search.entities.driver') + '/' + $t('search.entities.service_provider'),
                    $t('search.entities.license_plate'),
                    $t('search.entities.car_type'),
                  ].join(', '),
                })
              }}
            </small>
          </template>
        </HeaderComponent>
        <b-input-group>
          <b-form-input :value="filters.search" class="form-control-sm" :placeholder="$t('placeholders.search')" @input="updateFilter"></b-form-input>
          <b-input-group-append>
            <b-btn variant="secondary" size="sm" class="text-white border-gray" :disabled="!filters.search" @click="filters.search = ''">{{
              $t('actions.clear')
            }}</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <div id="planning-index" class="position-relative">
      <BlockingContainer v-if="$wait.is('job processing') || isBusy"></BlockingContainer>
      <b-table
        ref="asyncTable"
        small
        :items="itemsProvider"
        stacked="md"
        :busy.sync="isBusy"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :fields="fieldsTable"
        :no-sort-reset="true"
        table-class="no-min-width"
        tbody-tr-class="custom-tbody-tr-class cursor-pointer"
        :show-empty="true"
        @row-clicked="onRowClicked(...arguments)"
      >
        <template #head()="{ label, field: { key, sortable } }">
          <template v-if="key == 'chart'">
            <ECharts ref="echart" class="chart" :option="headerChartData" style="min-width: 400px; min-height: 50px; height: 50px" autoresize />
          </template>
          <template v-else>
            {{ label }}
          </template>
          <template v-if="sortable">
            <!-- Custom icons -->
            <template>
              <FontAwesomeIcon v-if="sortBy !== key" :icon="['fas', 'arrows-alt-v']" />
              <FontAwesomeIcon v-else-if="sortDesc" :icon="['fas', 'arrow-down']" />
              <FontAwesomeIcon v-else :icon="['fas', 'arrow-up']" />
            </template>
          </template>
        </template>

        <template v-slot:cell(location_from)="row">
          {{ row.item.location_from.name }}
        </template>
        <template v-slot:cell(location_to)="row">
          {{ row.item.location_to.name }}
        </template>
        <template v-slot:cell(vip)="row">
          {{ row.item.job.vip.name }}
        </template>
        <template v-slot:cell(driver_or_service_provider)="row">
          <div v-if="row.item.driver_id">{{ row.item.driver.name }}</div>
          <div v-if="row.item.service_provider_id">{{ row.item.service_provider.name }}</div>
        </template>
        <template v-slot:cell(car)="row">
          <span v-if="row.item.car"> {{ row.item.car.license_plate }} </span>
        </template>
        <template v-slot:cell(car_type)="row">
          <div v-if="row.item.car"> {{ row.item.car.car_type.name }} </div>
          <div v-else-if="row.item.car_type"> {{ row.item.car_type.name }} </div>
        </template>
        <template v-slot:cell(chart)="row">
          <ECharts
            :ref="`echart-#${row.item.id}`"
            class="chart"
            :option="row.item.chart_data"
            style="height: 35px; width: 100%; min-width: 400px; min-height: 35px"
            autoresize
            @mouseover="onChartMouseOver(row.item.chart_data)"
            @mouseout="onChartMouseOut(row.item.chart_data)"
            @click="onChartClick(row.item, $event)"
          />
        </template>
        <template v-slot:cell(empty)="row">
          <div class="text-center">{{ $t('messages.no_items') }}</div>
        </template>
      </b-table>
    </div>
    <ScheduledServiceTimeModal
      v-model="selectedScheduledServiceTime"
      :loaded-id="selectedScheduledServiceTime"
      :job="selectedScheduledServiceTimeJob"
      @updated="updateSST"
      @deleted="updateSST"
      @hidden="selectedScheduledServiceTime == null && selectedScheduledServiceTimeJob == null"
    />
  </Layout>
</template>
